import React, { useState, useEffect, useContext } from "react";
import {
  scaleLinear,
  clipPath,
  path,
  line,
  curveNatural,
  extent,
  format,
  node,
  select,
  max,
  parse,
  curveLinear,
  tickStep,
  ticks,
  min,
} from "d3";
import * as d3 from "d3";
import { useData } from "./useData";

import { AxisBottomPath } from "./AxisBottomPath";
import { AxisLeftPath } from "./AxisLeftPath";
import { RelativeHumidity } from "./RelativeHumidity";
import { Entalphy } from "./Entalphy";
import jsPDF from "jspdf";
import "svg2pdf.js";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { ProcessLine } from "./airProcesses/ProcessLine";
import ChartConfigPanel from "./ChartConfigPanel";
import { weatherCtx } from "../../utils/hooks/mollierWeatherContext";
import { useSelector } from "react-redux";
import {
  calculateEntalpy,
  calculateWithHumidities,
  apsolutnaVlaznostVazduha,
  dryBulbDewPoint,
  dryBulbWetBulb,
  dryBulbRelativeHumidity,
  dryBulbAbsoluteHumidity,
  dryBulbEnthalpy,
  wetBulbDewPoint,
  wetBulbRelativeHumidity,
  wetBulbAbsoluteHumidity,
  wetBulbEnthalpy,
  dewPointEnthalpy,
  dewPointAbsoluteHumidity,
  dewPointRelativeHumidity,
  dzavra,
} from "./calculations";

import { SwipeRight } from "@mui/icons-material";

import logoURL from "./../tecnicalCard/images/logo.png";
import AHU from "./AHU.png";
import RotaryPNG from "./images/RotaryPNG.png";
import CondensingPNG from "./images/CondensingPNG.png";
import EnthalpyPNG from "./images/EnthalpyPNG.png";
import RotaryCoils from "./images/RotaryCoils.png";
import EnthaplyCoils from "./images/EnthalpyCoils.png";
import CondensingCoils from "./images/CondensingCoils.png";
import { pdf } from "@react-pdf/renderer";
import { useMediaQuery } from "@mui/material";

function MollierPlot(props) {
  const { t } = useTranslation();

  //parametri za dijagram
  const width = props.isSmallScreen ? 350 : 800; //800!!!!
  // const width1 = 300;
  const height = props.isSmallScreen ? 400 : 900; //900!!!!!
  // const height1 = 600;
  const margin = {
    top: props.isSmallScreen ? 60 : 120,
    right: props.isSmallScreen ? 15 : 30,
    bottom: props.isSmallScreen ? 30 : 65,
    left: props.isSmallScreen ? 40 : 90,
  };
  const xAxisLabelOffset = props.isSmallScreen ? 20 : 40;
  const yAxisLabelOffset = props.isSmallScreen ? 20 : 45;
  const x = 0;
  const y = -10;

  const innerHeight = height - margin.top - margin.bottom;
  const innerWidth = width - margin.left - margin.right;
  //kraj definicije parametara

  const [data, setData] = useState([]);
  const [dataEntalpy, setDataEntalpy] = useState([]);
  const [loading, setLoading] = useState(true);
  const indoorPoint = useSelector(
    (state) => state.processPoint.summerPoints
  ).filter((item) => item.process === "indoor")[0];

  const indoorPointWinter = useSelector(
    (state) => state.winterPoints.winterPoints
  ).filter((item) => item.process === "indoor")[0];

  const [a, setA] = useState("");

  const incrementRelativeHumidity = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  const incrementEnthalpy = [
    -20, 0, -10, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110,
  ];
  const [dohvacenaLinija, setLinija] = useState("");
  const getLinePath = (linePath) => {
    setLinija(linePath);
    setLoading(false);
    //console.log(linePath);
  };

  //
  const handleGeneratePdf = () => {
    const doc = new jsPDF({
      format: "a4",
      unit: "pt",
      // compress: true,
    });

    const svgElement = d3.select("#svg");
    //Kreiranje kopije elementa + innerHTML-a
    const pdfElement = svgElement.clone();
    pdfElement.html(svgElement.html());
    // Scaling factor (adjust as needed)
    const scale = props.isSmallScreen ? 1.4 : 0.6;

    // Apply the scale transformation to the SVG element

    pdfElement.attr("transform", `scale(${scale})`);

    var parser = new DOMParser();
    var docSVG = parser
      .parseFromString(pdfElement._groups[0][0].outerHTML, "image/svg+xml") //
      .querySelector("svg");

    //Kreiranje zaglavlja
    doc.addImage(logoURL, "PNG", 25, 20, 220, 30);
    doc.setFontSize(12);
    doc.setFont("Helvetica");
    const weatherMode = summerWeather ? "Summer mode" : "Winter mode";
    doc.text(30, 70, "Mollier chart - " + weatherMode);
    doc.setFontSize(9);
    doc.text(30, 85, "Project name - " + props.projectInfo.projectName);
    doc.text(30, 95, "Position - " + props.positionName);
    doc.text(30, 105, "Revision - " + props.revisionNumber);
    doc.text(400, 85, "Location - " + props.projectInfo.location);
    doc.text(400, 95, "Elevation - " + props.chartConfig.altitude + "m");
    doc.text(
      400,
      105,
      "Air pressure - " + props.chartConfig.airPressure + "Pa"
    );

    //Slika komore na grafikonu
    props.DBMollier &&
      doc.addImage(
        props.unitType === "Rotary"
          ? props.coils === "without"
            ? RotaryPNG
            : RotaryCoils
          : props.unitType === "Enthalpy"
          ? props.coils === "without"
            ? EnthalpyPNG
            : EnthaplyCoils
          : props.coils === "without"
          ? CondensingPNG
          : CondensingCoils,
        "PNG",
        250,
        430,
        250,
        120
      );

    //Dodavanje tabele
    const elementTable = document.getElementById("processTable");
    // Calculate the width of each column (equal distribution)
    const columnWidth = 46;
    // Calculate the height of each row
    const rowHeight = 12;

    // Get the rows and cells from the table
    const rows = elementTable.getElementsByTagName("tr");
    const columnNames = elementTable.getElementsByTagName("th");
    doc.setFontSize(7);
    //  doc.setFont("Bold");
    //Dodavanje zaglavlja tabele

    for (let j = 0; j < columnNames.length; j++) {
      const columnName = columnNames[j].textContent || "";
      const maxColumnWidth = columnWidth - 2; // Reserve some space for padding
      let splittedColumnNames = doc.splitTextToSize(columnName, maxColumnWidth);
      for (let k = 0; k < splittedColumnNames.length; k++) {
        doc.setFont("Helvetica", "Bold");
        doc.text(
          j == 0
            ? props.DBMollier
              ? 70
              : 56
            : (props.DBMollier ? 38 : 27) + j * columnWidth,
          647 + k * 6,
          splittedColumnNames[k]
        );
      }

      doc.rect(
        j == 0
          ? props.DBMollier
            ? 65
            : 55
          : (props.DBMollier ? 36 : 25) + j * columnWidth,
        640,
        j == 0 ? 16 : columnWidth,
        22
      );
    }

    doc.setFont("Helvetica", "");
    //Dodavanje redova tabele
    doc.setFontSize(8);
    for (let i = 0; i < rows.length; i++) {
      const cells = rows[i].getElementsByTagName("td");
      for (let j = 0; j < cells.length; j++) {
        const cell = cells[j];
        const text = cell.textContent || "";
        doc.text(
          j == 0
            ? props.DBMollier
              ? 70
              : 60
            : (props.DBMollier ? 41 : 30) + j * columnWidth,
          660 + i * rowHeight,
          text
        );
        doc.rect(
          j == 0
            ? props.DBMollier
              ? 65
              : 55
            : (props.DBMollier ? 36 : 25) + j * columnWidth,
          650 + i * rowHeight,
          j == 0 ? 16 : columnWidth,
          rowHeight
        );
      }
    }
    const today = new Date();
    const date =
      today.getDate() +
      "/" +
      (today.getMonth() + 1) +
      "/" +
      today.getFullYear();
    doc.text(45, 800, date);
    doc.text(230, 800, "Frameless development version");
    doc.text(500, 800, "1/1");
    //Dodavanje dijagrama i cuvanje fajla
    doc.svg(docSVG, { x: 50, y: 90 }).then(() => {
      doc.save(`mollierChart_Position-${props.positionName}.pdf`);
      //Uklanjanje elementa kako se ne bi prikazao na strani
      pdfElement.remove();
    });
  };

  /* const rangeStart = props.chartConfig.minTemp;

  const rangeEnd = props.chartConfig.maxTemp;
  const tickCount = 10;
  const tickValues = ticks(rangeStart, rangeEnd, tickCount);
  console.log("Tick values" + tickValues);
  console.log("Range start" + rangeStart);
  console.log("Range end" + rangeEnd);
  console.log("Tick count" + tickCount);
  const step = tickStep(rangeStart, rangeEnd, tickCount);
  console.log("Step" + step);
  console.log("diference" + (rangeEnd - rangeStart));*/

  function customTicks(rangeStart, rangeEnd, step) {
    const tickCount = (rangeEnd - rangeStart) / step;
    const tickValues = ticks(rangeStart, rangeEnd, tickCount);

    if (rangeEnd % step === 0 && rangeStart % step === 0) {
      return tickValues;
    } else if (rangeEnd % step === 0 && rangeStart % step !== 0) {
      tickValues.unshift(rangeStart);
      return tickValues;
    } else if (rangeEnd % step !== 0 && rangeStart % step === 0) {
      tickValues.push(rangeEnd);
      return tickValues;
    } else {
      tickValues.unshift(rangeStart);
      tickValues.push(rangeEnd);
      return tickValues;
    }
  }

  const customTicksY = customTicks(
    props.chartConfig.minTemp,
    props.chartConfig.maxTemp,
    5
  );
  const customTicksYLine = customTicks(
    props.chartConfig.minTemp,
    props.chartConfig.maxTemp,
    1
  );

  const customTicksX = customTicks(
    props.chartConfig.minAbsoluteHumidity,
    props.chartConfig.maxAbsoluteHumidity,
    2
  );
  const customTicksXLine = customTicks(
    props.chartConfig.minAbsoluteHumidity,
    props.chartConfig.maxAbsoluteHumidity,
    1
  );

  const { summerWeather } = useContext(weatherCtx);
  const summerPoints = useSelector((state) => state.processPoint.summerPoints);
  const winterPoints = useSelector((state) => state.winterPoints.winterPoints);

  useEffect(() => {
    setData([]);
    setDataEntalpy([]);

    for (var i = 0; i <= 100; i += 10) {
      for (
        var j = props.chartConfig.minAbsoluteHumidity;
        j <= props.chartConfig.maxAbsoluteHumidity;
        j += 0.1
      ) {
        if (j === 0) j = 0.1;
        let newRow = calculateWithHumidities(j, i, props.chartConfig.altitude);

        //Pokusaj da u setu vrednosti ne postoje tacke sa vecom temperaturom od maksimuma i manjom od minimuma
        if (
          newRow.temperature < props.chartConfig.minTemp &&
          newRow.temperature > props.chartConfig.maxTemp
        )
          console.log(newRow);
        setData((data) => [...data, newRow]);
      }
    }

    for (var i = -20; i <= 140; i += 10) {
      for (
        var j = props.chartConfig.minAbsoluteHumidity;
        j <= props.chartConfig.maxAbsoluteHumidity;
        j += 1
      ) {
        //if (i === 0) continue;
        //if (j === 0) continue;
        let newRowEntalpy = calculateEntalpy(j, i, props.chartConfig.altitude);
        setDataEntalpy((dataEntalpy) => [...dataEntalpy, newRowEntalpy]);
      }
    }

    const coordinates1 = convertPathStringToCoordinates1(
      relHumidityPath
    ).filter((row) => row.y <= innerHeight);

    pathic = convertCoordinatesToPathString(coordinates1);
    setA(pathic);
  }, [props]);

  if (!data) {
    return <pre>Loading...</pre>;
  }

  const xValue = (d) => d.humidity;

  const xAxisLabel = `${t("mollier.absHum")} g/kg`;

  const yValue = (d) => d.temperature;
  const yAxisLabel = `${t("mollier.temp")} °C (Tdb)`;

  const xScale = scaleLinear()
    //.domain(extent(data, xValue))
    .domain([
      props.chartConfig.minAbsoluteHumidity,
      props.chartConfig.maxAbsoluteHumidity,
    ])
    .range([0, innerWidth]);
  //.nice();
  // .clamp(true);

  const yScale = scaleLinear()
    //.domain(extent(data, yValue))
    .domain([props.chartConfig.minTemp, props.chartConfig.maxTemp])
    .range([innerHeight, 0])
    .nice();
  // .clamp(true);

  //Kriva koja oznacava donju ivicu clippatha
  let relHumidityPath = line()
    .x((d) => xScale(xValue(d)))
    .y((d) => yScale(yValue(d)))
    .curve(curveNatural)(data.filter((row) => row.relativeHumidity === 100));

  let clipPathLine;

  //Provera kog tipa SVG elementa je odredjeni element
  // console.log(  clipPathLine instanceof);
  //const cao = select("line");
  //console.log(cao.node() instanceof SVGLineElement); // true
  let intersection = null;

  if (relHumidityPath != null) {
    //Ako je linija inicijalizovana onda se pocetna tacka zamenjuje M sa L kako bi bila nastavak okvira
    // clipPathLine = "L" + relHumidityPath.slice(1) + "Z";

    //*****Pokusaj nalazenja secenja linije sa x osom****/
    //Kreiranje novog SVG elementa koji ce sadrzati kopiju linije
    var relativePathCopy = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "path"
    );
    select(relativePathCopy).attr("d", relHumidityPath);
    let totalLengthCopy = relativePathCopy.getTotalLength();
    // console.log("Duzina putanje " + totalLengthCopy);

    let pointID = 0;
    for (let i = 0; i < totalLengthCopy; i++) {
      const point = relativePathCopy.getPointAtLength(i);
      //Ukoliko je odstojanje od donje ivice dijametra manje od 0.05 onda je to tacka preseka
      if (Math.abs(point.y) - 620 < 0.05) {
        intersection = point;
        pointID = i;

        /*  console.log(
          "Pozicija elementa ispred koga treba izabaciti tacke" + pointID
        );*/
        break;
      }
    }

    // console.log("X koordinata preseka" + intersection.x);

    //**********Pokusaj secenja linije*********/
    /*const lastXValue = max(
      data.filter((row) => row.relativeHumidity === 100),
      (d) => xValue(d)
    );
    const intersectionYValue = yScale.invert(620);
    const relHumidityPath1 = line()
      .x((d) => xScale(xValue(d)))
      .y((d) => {
        const yVal = yValue(d);
        if (yVal > intersectionYValue) {
          return yScale(intersectionYValue);
        } else {
          return yScale(yVal);
        }
      })
      .curve(curveNatural)(data.filter((row) => row.relativeHumidity === 100));

      */
    //*******Pokusaj substring metode za izbacivanje nepotrebnih tacaka********/
    // clipPathLine = "L" + relHumidityPath.slice(203) + "Z";

    // console.log(relHumidityPath1);
  } else clipPathLine = "";

  //Funkcija koja pretvara string putanje u niz tacaka ali greska removeAttribute is not a function
  function convertPathStringToCoordinates(pathString) {
    const pathObject = path();
    select(pathObject).attr("d", pathString);
    const commands = pathObject.normalizedCommands;
    const coordinates = [];

    for (let i = 0; i < commands.length; i++) {
      const command = commands[i];

      if (command.type === "C") {
        const x1 = command.values[0];
        const y1 = command.values[1];
        const x2 = command.values[2];
        const y2 = command.values[3];
        const x = command.values[4];
        const y = command.values[5];

        coordinates.push({ x: x1, y: y1 });
        coordinates.push({ x: x2, y: y2 });
        coordinates.push({ x: x, y: y });
      }
    }

    return coordinates;
  }

  //const coordinates = convertPathStringToCoordinates(relHumidityPath);
  //console.log(coordinates);

  let pathic = "";

  function convertPathStringToCoordinates1(pathString) {
    const regex =
      /C(-?\d+\.?\d*),(-?\d+\.?\d*),(-?\d+\.?\d*),(-?\d+\.?\d*),(-?\d+\.?\d*),(-?\d+\.?\d*)/g;
    const coordinates = [];

    let match = regex.exec(pathString);
    //console.log(match);
    while (match != null) {
      const x1 = parseFloat(match[1]);
      const y1 = parseFloat(match[2]);
      const x2 = parseFloat(match[3]);
      const y2 = parseFloat(match[4]);
      const x = parseFloat(match[5]);
      const y = parseFloat(match[6]);

      coordinates.push({ x1: x1, y1: y1, x2: x2, y2: y2, x: x, y: y });
      //coordinates.push({ x2: x2, y2: y2 });
      //coordinates.push({ x: x, y: y });

      match = regex.exec(pathString);
    }

    return coordinates;
  }

  function convertCoordinatesToPathString(coordinates) {
    let pathString = "";
    coordinates.forEach(({ x1, y1, x2, y2, x, y }) => {
      pathString += `C${x},${y},${x2},${y2},${x1},${y1}`;
    });
    return pathString;
  }

  //console.log(intersection.x);

  let maxHum = xScale.invert(innerWidth);
  let maxTemp = yScale.invert(innerHeight);
  let newRow = calculateWithHumidities(maxHum, 100, props.chartConfig.altitude);
  let druga = apsolutnaVlaznostVazduha(
    maxTemp,
    100,
    props.chartConfig.altitude
  );
  // console.log(newRow);
  // console.log(druga);

  //TEST GORNJA I LEVA MARGINA
  /*const clipPathPoints = [
    [innerWidth, yScale(newRow.temperature)],
    [innerWidth, 120],
    [90, 120],
    [90, innerHeight],
    [xScale(druga.humidity), innerHeight],
    //   [intersection.x + 1.5, innerHeight],
  ];*/

  //DOBROOOO!!!!
  var intersect = require("path-intersection");
  var intersection1 = intersect(dohvacenaLinija);
  const clipPathPoints = [
    [innerWidth, yScale(newRow.temperature)],
    [innerWidth, 0],
    [0, 0],
    [0, innerHeight],
    // [innerWidth, innerHeight],
    [xScale(druga.humidity), innerHeight],
    //   [intersection.x + 1.5, innerHeight],
  ];

  // Use D3's path function to generate the path for your clipping path
  const clipPathPath = path();
  clipPathPath.moveTo(...clipPathPoints[0]);
  clipPathPoints.slice(1).forEach((point) => clipPathPath.lineTo(...point));
  clipPathPath.closePath();

  // console.log(clipPathPath.toString());

  //console.log(relHumidityPath.length);

  /* const totalLength1 = document.getElementById("clip-path");

  function getSvgElementLength(el) {
    const constructor = el.constructor;
    switch (constructor) {
      case SVGPolylineElement:
        return getSvgPolylineLength(el);
      case SVGLineElement:
        return ((x1, x2, y1, y2) =>
          Math.sqrt((x2 -= x1) * x2 + (y2 -= y1) * y2))(
          el.getAttribute("x1"),
          el.getAttribute("x2"),
          el.getAttribute("y1"),
          el.getAttribute("y2")
        );
      case SVGRectElement:
        return el.getAttribute("width") * 2 + el.getAttribute("height") * 2;
      case SVGPathElement:
        return el.getTotalLength();
    }
  }

  function getSvgPolylineLength(el) {
    var totalLength = 0;
    var prevPos;
    for (var i = 0; i < el.points.numberOfItems; i++) {
      var pos = el.points.getItem(i);
      if (i > 0) {
        totalLength += Math.sqrt(
          Math.pow(pos.x - prevPos.x, 2) + Math.pow(pos.y - prevPos.y, 2)
        );
      }
      prevPos = pos;
    }
    return totalLength;
  }

  //const totalLength = document.getElementById("clip-path").getTotalLength();
  console.log(totalLength1);
  console.log(relHumidityPath instanceof SVGPolylineElement);
  console.log(relHumidityPath instanceof SVGLineElement);
  console.log(relHumidityPath instanceof SVGRectElement);
  console.log(relHumidityPath instanceof SVGPathElement);

  console.log("Inter" + relHumidityPath);*/

  /*const xIntercept = xScale(0); // x-coordinate of the x-axis
  const pathNode = select("line");
  let intersectionPoint = null;
  if (pathNode) {
    const pathLength = pathNode.getTotalLength();
    for (let i = 0; i < pathLength; i++) {
      const pathPoint = pathNode.getPointAtLength(i);
      if (Math.abs(pathPoint.x - xIntercept) < 0.1) {
        // adjust tolerance as needed
        intersectionPoint = pathPoint;
        break;
      }
    }
  }*/

  function nth_occurrence(string, char, nth) {
    var first_index = string.indexOf(char);
    var length_up_to_first_index = first_index + 1;

    if (nth == 1) {
      return first_index;
    } else {
      var string_after_first_occurrence = string.slice(
        length_up_to_first_index
      );
      var next_occurrence = nth_occurrence(
        string_after_first_occurrence,
        char,
        nth - 1
      );

      if (next_occurrence === -1) {
        return -1;
      } else {
        return length_up_to_first_index + next_occurrence;
      }
    }
  }

  clipPathLine =
    clipPathPath.toString().substring(0, clipPathPath.toString().length - 1) +
    "L" +
    //dohvacenaLinija.slice(1) +
    /*dohvacenaLinija.substring(
      nth_occurrence(dohvacenaLinija, ",", 4) + 1,
      dohvacenaLinija.length
    )  +*/
    a.substring(nth_occurrence(a, ",", 4) + 1, a.length) +
    "Z";
  //clipPathLine;

  //console.log("Kako" + clipPathLine);

  const siFormat = format(".2s");
  const xAxisTickFormat = (tickValue) => siFormat(tickValue).replace("G", "B");

  // console.log(dataEntalpy);

  //COMFORT PATH

  //NIZ KOORDINATA ZA LETNJI REZIM
  const comfortPathCoordinatesSummer = [
    {
      temperature: indoorPoint.temperatureDryBulb - 2,
      humidity: dzavra(
        indoorPoint.temperatureDryBulb - 2,
        indoorPoint.relativeHumidity - 10,
        0
      ).humidity,
    },
    {
      temperature: indoorPoint.temperatureDryBulb + 2,
      humidity: dzavra(
        indoorPoint.temperatureDryBulb + 2,
        indoorPoint.relativeHumidity - 10,
        0
      ).humidity,
    },
    {
      temperature: indoorPoint.temperatureDryBulb + 2,
      humidity: dzavra(
        indoorPoint.temperatureDryBulb + 2,
        indoorPoint.relativeHumidity + 10,
        0
      ).humidity,
    },
    {
      temperature: indoorPoint.temperatureDryBulb - 2,
      humidity: dzavra(
        indoorPoint.temperatureDryBulb - 2,
        indoorPoint.relativeHumidity + 10,
        0
      ).humidity,
    },
  ];
  //NIZ KOORDINATA ZA ZIMSKI REZIM
  const comfortPathCoordinatesWinter = [
    {
      temperature: indoorPointWinter.temperatureDryBulb - 2,
      humidity: dzavra(
        indoorPointWinter.temperatureDryBulb - 2,
        indoorPointWinter.relativeHumidity - 10,
        0
      ).humidity,
    },
    {
      temperature: indoorPointWinter.temperatureDryBulb + 2,
      humidity: dzavra(
        indoorPointWinter.temperatureDryBulb + 2,
        indoorPointWinter.relativeHumidity - 10,
        0
      ).humidity,
    },
    {
      temperature: indoorPointWinter.temperatureDryBulb + 2,
      humidity: dzavra(
        indoorPointWinter.temperatureDryBulb + 2,
        indoorPointWinter.relativeHumidity + 10,
        0
      ).humidity,
    },
    {
      temperature: indoorPointWinter.temperatureDryBulb - 2,
      humidity: dzavra(
        indoorPointWinter.temperatureDryBulb - 2,
        indoorPointWinter.relativeHumidity + 10,
        0
      ).humidity,
    },
  ];

  let komfort = line()
    .x((d) => xScale(xValue(d)))
    .y((d) => yScale(yValue(d)))
    .curve(curveLinear)(
    summerWeather ? comfortPathCoordinatesSummer : comfortPathCoordinatesWinter
  );
  //KRAJ FUNKCIJA ZA COMFORT ZONU

  // console.log(comfortPathCoordinates);
  //console.log(komfort);

  incrementRelativeHumidity.map((i) => {
    let filter = data.filter((row) => row.relativeHumidity === i);
    let filterY = filter.filter((row) => row.temperature - 40 <= 0.05);
    // console.log(filter);
    // console.log(filterY);
    //  console.log(max(filterY, (d) => xValue(d)));
    //  console.log(xScale(max(filterY, (d) => xValue(d))));
  });
  incrementRelativeHumidity.map((i) => {
    /* console.log(
      yScale(
        max(
          data
            .filter(
              (row) =>
                row.humidity <= props.chartConfig.maxAbsoluteHumidity &&
                row.temperature <= props.chartConfig.maxTemp
            )
            .filter((row) => row.relativeHumidity === i),
          //  .filter((row) => row.temperature - 40 <= 0.05),
          (d) => yValue(d)
        )
      )
    );*/
  });
  //Dijagram
  const clipPathPointsSquare = [
    [innerWidth, 0],
    [0, 0],
    [0, innerHeight],
    [innerWidth, innerHeight],

    //   [intersection.x + 1.5, innerHeight],
  ];

  // Use D3's path function to generate the path for your clipping path
  const clipPathSquare = path();
  clipPathSquare.moveTo(...clipPathPointsSquare[0]);
  clipPathPointsSquare
    .slice(1)
    .forEach((point) => clipPathSquare.lineTo(...point));
  clipPathSquare.closePath();
  // let linePoints = [];
  /*let linePoints = [
    { temperature: 20, humidity: 4.8 },
    { temperature: 24, humidity: 4.8 },
  ];*/
  //let linePoints = heating(5, 4, 24);
  /*let linePoints = cooling(
    24.6,
    8.2,
    16,
    null,
    24595,
    null,
    7.79,
    10,
    0,
    100,
    45.7,
    8.2
  );*/
  /* summerWeather
    ? summerPoints.map((point, index) => {
        console.log(JSON.stringify(point) + "index" + index + (index != 1));
        if (index != 1) {
          linePoints.push({
            temperature: +point.temperatureDryBulb,
            humidity: point.absoluteHumidity,
            process: point.process,
          });
        }
      })
    : winterPoints.map((point, index) => {
        if (index != 1)
          linePoints.push({
            temperature: point.temperatureDryBulb,
            humidity: point.absoluteHumidity,
            process: point.process,
          });
      });

  console.log(linePoints);*/

  return (
    <>
      <svg width={width} height={height} id="svg">
        <defs>
          <clipPath id="clip-path">
            <path stroke="red" d={clipPathLine} strokeWidth="0.3" />
          </clipPath>
          <clipPath id="clip-path-square">
            <path d={clipPathSquare} strokeWidth="0.3" />
          </clipPath>
        </defs>
        <g transform={`translate(${margin.left},${margin.top})`}>
          <path
            // className="comfortZone"
            fill="#e8e8e8"
            //stroke=" rgb(53, 53, 55)"
            // opacity="0.2"
            d={komfort}
            clipPath="url(#clip-path)"
          />

          {customTicksX.map((tickValue) => (
            <text
              transform={`translate(${xScale(tickValue)},0)`}
              font-family="Poppins, sans-serif"
              style={{ textAnchor: "middle" }}
              fontSize={props.isSmallScreen ? 8 : 16}
              y={-10}
            >
              {tickValue}
            </text>
          ))}
          {customTicksXLine.map((tickValue) => (
            <AxisBottomPath
              xScale={xScale}
              innerHeight={innerHeight}
              tickOffset={7}
              //  valuesX={customTicksX}
              // yScale={yScale}
              //  xValue={xValue}
              // yValue={yValue}
              tickValue={tickValue}
              tickValueMax={customTicksX[customTicksX.length - 1]}
              isSmallScreen={props.isSmallScreen}
            />
          ))}

          <text
            //className="axis-label"

            fill="#3d3d3c"
            textAnchor="middle"
            font-family="Poppins, sans-serif"
            fontSize={props.isSmallScreen ? 8 : 16}
            transform={`translate(${-yAxisLabelOffset},${
              innerHeight / 2
            }) rotate(-90)`}
          >
            {yAxisLabel}
          </text>

          {customTicksY.map((tickValue) => (
            <text
              // className="tick"
              key={tickValue}
              font-family="Poppins, sans-serif"
              style={{ textAnchor: "start" }}
              x={props.isSmallScreen ? -12 : -25}
              dy=".32em"
              transform={`translate(0,${yScale(tickValue)})`}
              fontSize={props.isSmallScreen ? 8 : 16}
            >
              {tickValue}
            </text>
          ))}
          {customTicksYLine.map((tickValue) => (
            <AxisLeftPath
              yScale={yScale}
              innerWidth={innerWidth}
              tickOffset={props.isSmallScreen ? 3 : 7}
              //valuesY={customTicksY}
              tickValue={tickValue}
              tickValueMax={customTicksY[0]}
              isSmallScreen={props.isSmallScreen}
            />
          ))}
          <text
            // className="axis-label"
            fill="#3d3d3c"
            x={innerWidth / 2}
            y={-xAxisLabelOffset}
            textAnchor="middle"
            font-family="Poppins, sans-serif"
            fontSize={props.isSmallScreen ? 8 : 16}
          >
            {xAxisLabel}
          </text>
          {incrementRelativeHumidity.map((i) => (
            <RelativeHumidity
              data={data.filter(
                (row) =>
                  row.humidity <= props.chartConfig.maxAbsoluteHumidity &&
                  row.temperature <= props.chartConfig.maxTemp
              )}
              xScale={xScale}
              yScale={yScale}
              xValue={xValue}
              yValue={yValue}
              tooltipFormat={xAxisTickFormat}
              percentage={i}
              returnClipPathLine={getLinePath}
              isSmallScreen={props.isSmallScreen}
            />
          ))}
          {incrementEnthalpy.map((i) => (
            <>
              <Entalphy
                data={dataEntalpy}
                xScale={xScale}
                yScale={yScale}
                xValue={xValue}
                yValue={yValue}
                tooltipFormat={xAxisTickFormat}
                enthalpy={i}
                intersectionPath={relHumidityPath}
                isSmallScreen={props.isSmallScreen}
              />
              {/* <text
              className="axis-label"
              textAnchor="middle"
              transform={`translate(${innerWidth},${yScale(
                yValue(dataEntalpy)
              )})`}
            >
              {i + " %"}
              </text>*/}
            </>
          ))}

          {props.DBMollier && (
            <>
              <ProcessLine
                data={
                  summerWeather
                    ? summerPoints.slice(0, summerPoints.length - 2)
                    : winterPoints.slice(0, winterPoints.length - 2)
                }
                xScale={xScale}
                yScale={yScale}
                xValue={xValue}
                yValue={yValue}
                tooltipFormat={xAxisTickFormat}
                dllProcess={"SUP"}
                isSmallScreen={props.isSmallScreen}
                heater={!summerWeather && winterPoints.length > 4}
                cooler={summerWeather && summerPoints.length > 4}
              />

              <ProcessLine
                data={
                  summerWeather
                    ? summerPoints.slice(summerPoints.length - 2)
                    : winterPoints.slice(winterPoints.length - 2)
                }
                xScale={xScale}
                yScale={yScale}
                xValue={xValue}
                yValue={yValue}
                tooltipFormat={xAxisTickFormat}
                dllProcess={"EHA"}
                isSmallScreen={props.isSmallScreen}
                heater={!summerWeather && winterPoints.length > 4}
                cooler={summerWeather && summerPoints.length > 4}
              />
            </>
          )}
          {!props.DBMollier && (
            <ProcessLine
              data={
                summerWeather
                  ? summerPoints.length >= 3 && summerPoints[2].process === 30
                    ? summerPoints
                    : summerPoints.filter((item) => item.id != 1)
                  : winterPoints.length >= 3 && winterPoints[2].process === 30
                  ? winterPoints
                  : winterPoints.filter((item) => item.id != 1)
              }
              xScale={xScale}
              yScale={yScale}
              xValue={xValue}
              yValue={yValue}
              tooltipFormat={xAxisTickFormat}
              dllProcess={""}
              isSmallScreen={props.isSmallScreen}
            />
          )}
        </g>
      </svg>
      <ChartConfigPanel
        handleConfigChange={props.handleConfigChange}
        handleAxisChange={props.handleAxisChange}
        minTemp={props.chartConfig.minTemp}
        maxTemp={props.chartConfig.maxTemp}
        minAbsoluteHumidity={props.chartConfig.minAbsoluteHumidity}
        maxAbsoluteHumidity={props.chartConfig.maxAbsoluteHumidity}
        altitude={props.chartConfig.altitude}
        airflow={props.chartConfig.airflow}
        DBMollier={props.DBMollier}
        handleGeneratePdf={handleGeneratePdf}
        isSmallScreen={props.isSmallScreen}
      />
    </>
  );
}
export default MollierPlot;
